import palette from './palette';
import {
  spacing,
  fontSizes,
  fontWeights,
  radii,
  breakpoints,
  shadows,
  transitions,
} from './tokens';

// Theme do modo escuro consumido pelo ThemeProvider (styled-components).
// As cores vem da paleta unica (src/themes/palette.js). Para mudar uma
// cor do sistema, edite la — NAO edite este arquivo.
export default {
  title: 'dark',
  colors: palette.dark,

  spacing,
  fontSizes,
  fontWeights,
  radii,
  breakpoints,
  shadows,
  transitions,
};
